const getInitials = (name: string, separator = '.'): string =>
  name
    .split(' ')
    .map((n) => n[0].toUpperCase())
    .join(separator);

export default getInitials;
